/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Toaster, toast } from "react-hot-toast";
import { RotatingLines } from "react-loader-spinner"; // Import the spinner
import "./Login.css";
import api from "./utils/Api";
import { Eye, EyeSlash } from "phosphor-react";

const Login = () => {
  const [mobileNumber, setMobileNumber] = useState(""); // Input field for mobile number
  const [otp, setOtp] = useState("");
  const [otpReceived, setOtpReceived] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [receivedOtp, setReceivedOtp] = useState(""); // Store OTP received from API
  const [username, setUsername] = useState(""); // Store username received from API
  const [authToken, setAuthToken] = useState(""); // Store authToken received from OTP verification
  const navigate = useNavigate(); // Hook to navigate to home page
  const [password, setPassword] = useState("");
const [showPasswordLogin, setShowPasswordLogin] = useState(false);
const [showPassword, setShowPassword] = useState(false);



  // Handle mobile number input change
  const handleMobileNumberChange = (e) => {
    setMobileNumber(e.target.value);
  };

  // Handle OTP input change
  const handleOtpChange = (e) => {
    setOtp(e.target.value);
  };

  // API call to get OTP
  const handleGetOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOtpError(""); // Clear any previous errors

    const fd = new FormData();
    fd.append("username", mobileNumber); // Send mobile number as "username" to API
    fd.append("programType", "verifyAndSendOTP");

    try {
      const response = await api.post(
        // "https://api.sarvajna.co.in/erp/auth/parentLoginCurl",
        // "https://admin.sarvajna.co.in/parentapp/api/controllers/auth/parentLoginCurl",
        "parentApp/login2",
        fd
      );

      console.log("res",response)

      if (response.data.code === "200") { // Ensure correct type checking
        const data = response.data; // ✅ No need for response.json()
  
        if (data?.data?.otp && data?.data?.username) {
          setOtpReceived(true);
          setReceivedOtp(data.data.otp); // Store OTP from server
          setUsername(data.data.username); // Store username for verification
          localStorage.setItem("username", data.data.username); // ✅ Store username in local storage
          toast.success("OTP sent successfully!");
        } else {
          toast.error("Invalid mobile number.");
        }
      } else {
        toast.error(response.data.data);
      }
    } catch (error) {
      toast.error("Failed to send OTP.");
      console.error("Error during OTP request:", error);
    } finally {
      setLoading(false);
    }
  };

  // Handle form submission to verify OTP
  const handleVerifyOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOtpError("");
  
    const fd = new FormData();
    fd.append("username", username);
    fd.append("otp", otp);
    fd.append("programType", "verifyOtp");
  
    try {
      const response = await api.post("parentApp/login2", fd);
      const data = response.data;
  
      if (data.success && data?.data?.authToken) {
        const authToken = data.data.authToken;
        setAuthToken(authToken);
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("username", data.data.authToken);
        toast.success("Login successful!");
        navigate("/students"); // ✅ redirect after OTP login
      } else {
        toast.error("Failed to verify OTP.");
      }
    } catch (error) {
      toast.error("Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };
  

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };
  

  const loginWithPassword = async (e) => {
    e.preventDefault();
    setLoading(true);
    setOtpError("");
  
    const fd = new FormData();
    fd.append("username", mobileNumber);
    fd.append("password", password);
    fd.append("programType", "loginWIthPassword");
  
    try {
      const response = await api.post("parentApp/login2", fd);
      console.log("res", response)
      
      const data = response.data;
      console.log("data", data)

  
      if (data.success) {
        const authToken = data.data.authToken;
        setAuthToken(authToken);
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("username", data.data.authToken);
        toast.success("Login successful!");
        navigate("/students"); // ✅ redirect after password login
      } else {
        toast.error("Failed to verify OTP.");
      }
    } catch (error) {
      toast.error("Failed to verify OTP.");
    } finally {
      setLoading(false);
    }
  };
  


  const callGetTokenApi = async (authToken) => {
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("authToken", authToken); // Send the authToken
      fd.append("programType", "getToken"); // Specify program type to get token

      const response = await fetch(
        // "https://api.sarvajna.co.in/erp/token/tokenCurl",
        // "https://admin.sarvajna.co.in/parentapp/api/controllers/token/tokenCurl",
        "https://api.sarvajna.co.in/owner/token/tokenCurl",

        {
          method: "POST",
          body: fd,
        }
      );

      const data = await response.json();

      // console.log("ss", data);

      if (data.success) {
        localStorage.setItem("authToken", authToken);
        localStorage.setItem("token", data.data); // Assuming the token is in data.data
        localStorage.getItem("token") && navigate("/students"); // Change to your actual home route
      } else {
        toast.error("Failed to get token.");
      }
    } catch (error) {
      toast.error("Failed to get token.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <Toaster position="top-center" /> {/* Add Toaster here */}
      <div className="login-wrapper d-flex" style={{ paddingTop: "90px" }}>
        <div className="container">
          <div className="text-center px-4">
            <img
              className="login-intro-img"
              src="assets/img/bg-img/Untitled (Logo).png"
              alt="Login Illustration"
              width={"200px"}
            />
          </div>

          <div className="register-form mt-4">
          


{showPasswordLogin ? (
  <form onSubmit={loginWithPassword}>
    <div className="form-group ">
      <input
        className="form-control large-input"
        type="text"
        id="mobileNumber"
        placeholder="Mobile Number"
        value={mobileNumber}
        onChange={handleMobileNumberChange}
        disabled={loading}
      />
    </div>
    <div className="form-group mt-3" style={{ position: "relative" }}>
    <input
  className="form-control large-input"
  type={showPassword ? "text" : "password"} // toggle input type for password visibility
  id="password"
  placeholder="Enter Password"
  value={password}
  onChange={handlePasswordChange}
  disabled={loading}
  style={{ paddingRight: "40px" }} // space for icon
/>
<span
  onClick={() => setShowPassword(!showPassword)}  // TOGGLE PASSWORD VISIBILITY HERE
  style={{
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    cursor: "pointer",
    color: "#888",
    userSelect: "none",
    fontSize: "18px",
  }}
>
  {showPassword ? (
    <EyeSlash size={20} weight="bold" />
  ) : (
    <Eye size={20} weight="bold" />
  )}
</span>
</div>

    <button
      className="btn btn-primary w-100 large-button mt-3"
      type="submit"
      disabled={loading}
    >
      {loading ? (
        <RotatingLines
          strokeColor="white"
          strokeWidth="5"
          animationDuration="0.75"
          width="24"
          visible={true}
        />
      ) : (
        "Login"
      )}
    </button>
  </form>
) : (
  <form onSubmit={otpReceived ? handleVerifyOtp : handleGetOtp}>
    <div className="form-group">
      <input
        className="form-control large-input"
        type="numeric"
        id="mobileNumber"
        placeholder="Mobile Number"
        value={mobileNumber}
        onChange={handleMobileNumberChange}
        disabled={loading}
      />
    </div>
    {otpReceived && (
      <div className="form-group mt-3">
        <input
          className="form-control large-input"
          type="numeric"
          id="otp"
          placeholder="Enter OTP"
          value={otp}
          onChange={handleOtpChange}
        />
      </div>
    )}
    <button
      className="btn btn-primary w-100 large-button"
      type="submit"
      disabled={loading}
    >
      {loading ? (
        <RotatingLines
          strokeColor="white"
          strokeWidth="5"
          animationDuration="0.75"
          width="24"
          visible={true}
        />
      ) : otpReceived ? (
        "Verify OTP"
      ) : (
        "Get OTP"
      )}
    </button>
  </form>
)}

<div style={{display:"flex", justifyContent:"center", marginTop:"20px"}}> 
          <p

  style={{color:"#017BFE", textDecoration:"underline", cursor:"pointer"}}
  onClick={() => setShowPasswordLogin((prev) => !prev)}
>
  {showPasswordLogin ? "Login with OTP" : "Login with Password"}
</p>
</div>


            {otpError && (
              <div
                style={{ color: "red", fontSize: "13px", marginTop: "10px" }}
              >
                {otpError}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
